export default __webpack_public_path__ + "static/media/dipLogoEntrepriseTC.ae90d4b8.webp";